// import React, { useState, useEffect, useMemo } from "react";
// import Modal from "react-awesome-modal";
// import { delete_blog, delete_link, delete_banner } from "../auth/service";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const DeleteModal = ({ type, id }) => {
//   console.log("Bann", type, id);
//   // const [state, updatestate] = useState(false);
//   const [state, updatestate] = useState(true);

//   const openModal = (e) => {
//     updatestate(true);
//   };
//   const closeModal = () => {
//     updatestate(false);
//     // window.location.reload();
//   };
//   const deleteItem = async () => {
//     try {
//       let resp;
//       if (type == "Blog") {
//         const res = await delete_blog(id);
//         resp = res;
//       } else if (type == "Banner") {
//         const res = await delete_banner({ bannerId: id });
//         resp = res;
//       } else if (type == "Link") {
//         const res = await delete_link({ pressId: id });
//         resp = res;
//       }
//       if (!resp.error) {
//         toast.success(resp.message);
//         closeModal();
//       }
//       // if (!resp.error) {
//       //   toast.success(resp.message, {
//       //     autoClose: 1500,
//       //     onClose: () => {
//       //       window.location.reload();
//       //     },
//       //   });

//       //   closeModal();
//       // }
//       else {
//         toast.error(resp.message);
//       }
//     } catch (error) {
//       toast.error("something went wrong");
//     }
//   };
//   // useMemo(() => {
//   //   openModal();
//   // }, []);
//   // useEffect(() => {
//   //   openModal();
//   // }, []);
//   return (
//     <>
//       <Modal
//         visible={state}
//         width="700"
//         height="200"
//         effect="fadeInUp"
//         // onClickAway={closeModal}
//         onClickAway={closeModal}
//       >
//         <div style={{ display: "grid", placeItems: "center", height: "100%" }}>
//           <div className="blog_heading" style={{ paddingLeft: 0 }}>
//             Are you sure you want to delete this?
//           </div>
//           <div>
//             <button
//               type="button"
//               className="modal_btn"
//               style={{ background: "#312968" }}
//               onClick={closeModal}
//             >
//               cancel
//             </button>
//             <button
//               type="button"
//               className="modal_btn"
//               style={{ background: "red" }}
//               onClick={deleteItem}
//             >
//               Confirm
//             </button>
//           </div>
//         </div>
//       </Modal>
//       {/* <ToastContainer autoClose={1500} /> */}
//     </>
//   );
// };

// export default DeleteModal;

import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { delete_blog, delete_link, delete_banner } from "../auth/service";
import { toast } from "react-toastify";

const DeleteModal = ({ type, id, handleClose, refreshData }) => {
  const deleteItem = async () => {
    try {
      let resp;

      if (type === "Blog") {
        resp = await delete_blog(id);
      } else if (type === "Banner") {
        resp = await delete_banner({ bannerId: id });
      } else if (type === "Link") {
        resp = await delete_link({ pressId: id });
      }

      if (!resp.error) {
        toast.success(resp.message);
        handleClose(); // 🔥 THIS closes MUI modal
        refreshData();
      } else {
        toast.error(resp.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
      }}
    >
      <Typography variant="h6" mb={2}>
        Are you sure you want to delete this?
      </Typography>

      <Box display="flex" justifyContent="flex-end" gap={2}>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>

        <Button variant="contained" color="error" onClick={deleteItem}>
          Confirm
        </Button>
      </Box>
    </Box>
  );
};

export default DeleteModal;
